import { useBaseRootActions } from '../../baseRoot.actions';
import { configSegmentoAtom } from './ConfigSegmentoState';

function useConfigSegmentoActions() {
  const baseActions = useBaseRootActions('configSegmentos', configSegmentoAtom);

  return {
    list: baseActions.list,
    get: baseActions.get,
    create: baseActions.create,
    update: baseActions.update,
    delete: baseActions.delete,
  };
}

export { useConfigSegmentoActions };
